import { Component, EventEmitter, Output, inject } from '@angular/core';
import { ShoppingCartLine } from '../../classes/shoppingcartline';
import { ShoppingCartService } from '../../service/shoppingcart.service';
import { UserService } from '../../service/user.service';
import { ActiveOrderService } from '../../service/active.order.service';

@Component({
    selector: 'shoppingcart-header-mobile-component',
    styleUrls: ['shoppingcart.header.component.scss'],
    templateUrl: 'shoppingcart.header.mobile.component.html',
    standalone: true
})
export class ShoppingcartHeaderMobileComponent {
  private activeOrderService = inject(ActiveOrderService);
  private shoppingCartService = inject(ShoppingCartService);
  private userService = inject(UserService);

  @Output() viewOrderDetailClickEvent = new EventEmitter();
  @Output() viewShoppingcartClickEvent = new EventEmitter();

  isFastCheckout(): boolean {
    return this.userService.isUseFastCheckout();
  }

  showShoppingCart(): boolean {
    return this.activeOrderService.hasSelectedOrder();
  }

  get shoppingCartLines(): Array<ShoppingCartLine> {
    return this.shoppingCartService.activeShoppingCartLines;
  }

  viewOrderDetail() {
    this.viewOrderDetailClickEvent.emit();
  }

  viewShoppingcart() {
    this.viewShoppingcartClickEvent.emit();
  }

  /**
   * Gets the number of items in the shopping cart.
   *
   * @returns {number}
   */
  getShoppingCartCount(): number {
    let size = 0;

    if (this.shoppingCartLines) {
      size = this.shoppingCartLines.length;
    }

    return size;
  }
}
